<template>
  <div class="container">
      <div class="body_top" v-if="noticeLabel">
            <div class="body_top_left">
                   <img v-if="noticeLabel=='园区公告'" class="body_top_left_icon" src="../../assets/images/icon_notice_park.png">
                     <img v-else-if="noticeLabel=='新闻动态'" class="body_top_left_icon" src="../../assets/images/icon_notice_news.png"/>
                     <img v-else class="body_top_left_icon" src="../../assets/images/icon_notice_weather.png"/>
                    <span class="body_top_left_span">{{noticeLabel}}</span>
            </div>
            <span class="body_top_right">{{noticeTime }}</span>
     </div>
     <div class="body_body">
         <textarea class="textarea" name="name" placeholder="留言将由工作人员筛选后显示，对所有人可见" v-model="message"></textarea>
     </div>

     <div class="foot">
         <div v-if="message.length > 0" class="foot_button" @click="saveCommentAction()">留言</div>
         <div v-else class="foot_button_gray" >留言</div>
     </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import { saveComment } from "../../utils/api";
import util from '../../utils/util';
export default {
  name: "noticeList",
//   components: {
//      Scroll,
//   },
   computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      list:[1,2,3,4,5,6,7,8,9,10],
      allLoaded:true, //是否能加载更多
      message:'',
      noticeID:'',
      noticeLabel:'',
      noticeTime:'',
    }
  },

  filters: {

    formatTime(val){
      return util.formatTime(new Date(val),4)
      //configObj.formatTime(new Date(val),'-','yyyymmdd');
    }
  },


  created() {
    //this.getNoticeListAction();
  },

 activated () {
    let query = this.$route.query;
    this.noticeID = query.noticeID;
    this.noticeLabel = query.noticeLabel;
    this.noticeTime =query.noticeTime;
    console.log(this.noticeLabel);
    console.log(this.noticeTime);
 },


  methods: {
      saveCommentAction(){
          let params = {
            "userId": this.common.userId,
            "bussinessId": this.noticeID,
            "commentType": "1",
            "isDrop": "0",
            "commentContent": this.message,
             marketId: "4"|| this.common.marketInfo.id,
          }

          saveComment(params).then(res => {
           // this.saveStatus = true;
            console.log(res);
            if (res.res.code === 10000) {
              this.$router.go(-1)
                // this.$router.push(`/noticeDetail/${this.noticeID}`);
            }
        });

      }

  }
}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #F3F4F6;
}

.body_top{
  width: 100%;
  height: 88px;
  border-radius:8px 8px 0px 0px;
  background-color:#FAFAFA;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #eaeaea;

}

.body_top_left{
  flex-direction: row;
  display: flex;
  margin-left: 28px;
}
.body_top_left_icon{
  display: flex;
  width: 44px;
  height: 44px;
}
.body_top_left_span{
  margin-left: 20px;
  height:40px;
  font-size:28px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:40px;
}

.body_top_right{
  margin-right: 28px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;

}

.body_body{
    flex-direction: column;
    width: 100%;
    display: flex;
    background-color: #fff;
}

.textarea {
  margin-left: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 694px;
  display: flex;
  background-color: #fff;
  font-size: 24px;
  height: 400px;
  line-height:34px;
}

.foot{
    .flex();
    //justify-content: center;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 108px;
    margin:0 auto;
    background: #fff;
    box-shadow: 0px 0px .18rem 0px rgba(0, 0, 0, 0.05);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index:100;
  }
  .foot_button{
    // margin-top: 16px;
    margin-left:28px;
    width: 694px;
    height: 76px;
    text-align: center;
    background-color: #0087ff;
    font-size:28px;
    font-weight:400;
    color:#ffffff;
    line-height:76px;

  }
  .foot_button_gray{
    margin-left:28px;
    width: 694px;
    height: 76px;
    text-align: center;
    background-color: #DADADA;
    font-size:28px;
    font-weight:400;
    color:#ffffff;
    line-height:76px;
  }

</style>